module.exports = __webpack_public_path__ + "static/prep-hero-eb10cd1ffbc107af1915971e4d00008d.jpg";